import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import n4Logo from '@/assets/n4-logo.webp';

const navLinks = [
  { href: '/', label: 'HOME' },
  { href: '/nutrition', label: 'NUTRITION' },
  { href: '/neurodevelopment', label: 'NEURODEVELOPMENT' },
  { href: '/neonatology', label: 'NEONATOLOGY' },
  { href: '/northpop', label: 'NORTHPOP' },
  { href: '/publications', label: 'PUBLICATIONS' },
  { href: '/about', label: 'ABOUT US' },
];

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-20 md:h-24 lg:h-28 items-center justify-between">
        <Link to="/" className="flex items-center">
          <img 
            src={n4Logo} 
            alt="N4 Research Group" 
            className="h-14 md:h-16 lg:h-20 w-auto"
            width={188}
            height={56}
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden items-center gap-8 lg:flex">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={cn(
                'text-sm font-medium transition-colors hover:text-secondary uppercase tracking-wide pb-1 border-b-2',
                location.pathname === link.href
                  ? 'text-secondary border-secondary'
                  : 'text-muted-foreground border-transparent'
              )}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Empty div to maintain layout balance */}
        <div className="hidden lg:flex w-16" />

        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </Button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="border-t lg:hidden">
          <nav className="container flex flex-col gap-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={cn(
                  'text-sm font-medium transition-colors hover:text-secondary uppercase tracking-wide',
                  location.pathname === link.href
                    ? 'text-secondary'
                    : 'text-muted-foreground'
                )}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
